import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { UrlTranslationE3ToE2Response } from '../../model/url-translation-e3-to-e2/url-translation-e3-to-e2-response.model';

@Injectable({
    providedIn: 'root'
})
export class UrlTranslationE3ToE2Service {

    protected resourceURL: string = "/rest/publicarea/translation/url"

    constructor(private http: HttpClient) { }

    findURLServiceDetail(serviceId: number): Observable<UrlTranslationE3ToE2Response> {
        return this.http.get<{ok: boolean, messageCode: string, messageDesc: string, entity: UrlTranslationE3ToE2Response}>(`${this.resourceURL}/serviceDetail/${serviceId}`).pipe(map(r => {
            if (!r.ok) {
                console.log("Error url service detail: " + r.messageCode + " - " + r.messageDesc)
            }

            return r.entity
        }))
    }

    findURLProcedureDetail(serviceId: number, procedureId: number): Observable<UrlTranslationE3ToE2Response> {
        return this.http.get<{ok: boolean, messageCode: string, messageDesc: string, entity: UrlTranslationE3ToE2Response}>(`${this.resourceURL}/procedureDetail/${serviceId}/${procedureId}`).pipe(map(r => {
            if (!r.ok) {
                console.log("Error url procedure detail: " + r.messageCode + " - " + r.messageDesc)
            }

            return r.entity
        }))
    }

    findURLFileDetail(procedureInstance: number): Observable<UrlTranslationE3ToE2Response> {
        return this.http.get<{ok: boolean, messageCode: string, messageDesc: string, entity: UrlTranslationE3ToE2Response}>(`${this.resourceURL}/fileDetail/${procedureInstance}`).pipe(map(r => {
            if (!r.ok) {
                console.log("Error url file detail: " + r.messageCode + " - " + r.messageDesc)
            }

            return r.entity
        }))
    }

}
